// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d427759","239":"d7b4984f","453":"d56100f9","455":"d667ee0d"}[chunkId] + ".chunk.js";
};